export default __webpack_public_path__ + "static/precision-piece-2-d77f2fef93b47aa1975e124c00ec2865.jpg";